<template>
  <b-form-group
    label="Kode Barang"
    label-for="kodeBarang"
    label-class="pb-0 pt-0"
  >
    <b-form-input
      v-model="kobar"
      disabled
    />
  </b-form-group>
</template>
<script>
export default {
  props: {
    kobar: { type: String, default: '' },
  },
}
</script>
